import { connect } from 'react-redux'

import Accessibe from './Accessibe'

import { setIsAccessibe } from 'src/modules/App/actions'

const mapStateToProps = (state) => {
  return {
    isAccessibe: state.appReducer.isAccessibe,
  }
}

const mapDispatchToProps = {
  setIsAccessibe
}

export default connect(mapStateToProps, mapDispatchToProps)(Accessibe)
